<template lang="pug">
  div
    .row
      .col-xl-6
        .heading--section Asset Summary
        .pad_t--5.text--size_13.text--color_grey Last updated: {{ ui_controls.lastUpdatedDate }}

      .col-xl-6
        .align__right.align__left-lg.mt-2
          b-button-group
            b-button(:class="{ active: isChart }", @click="CHANGE_TAB('chart')", size="sm")
              small.text-uppercase Chart
            b-button(:class="{ active: isTable }", @click="CHANGE_TAB('table')", size="sm")
              small.text-uppercase Table

    .mt-3
      Loading(:isLoading="isDataLoading", type="bar")
        AssetGraphic(v-if="ui_controls.currentTab === 'chart'", :cash="cash", :shares="shares")
        AssetTable(v-if="ui_controls.currentTab === 'table'", :cash="cash", :shares="shares")

</template>



<script>
  import AssetTable from "@/components/assetSummary/AssetTable";
  import AssetGraphic from "@/components/assetSummary/AssetGraphic";
  import Loading from "@/components/Loading";

  import requestHandlers from "@/mixins/requestHandlers";

  export default {
    mixins: [requestHandlers],

    components: {
      Loading,
      AssetTable,
      AssetGraphic
    },


    data: () => ({
      ui_controls: {
        currentTab: 'chart',
        lastUpdatedDate: null,
      },

      cash: [],
      shares: [],
    }),


    computed: {
      isChart() {
        return this.ui_controls.currentTab === "chart";
      },
      isTable() {
        return this.ui_controls.currentTab === "table";
      }
    },


    methods: {
      CHANGE_TAB(tab) {
        this.ui_controls.currentTab = tab;
      },

      async FETCH_RECORDS() {
        this.REQUEST_INIT();

        try {
          let { data } = await this.$axios.get('/Portfolio/AssetSummary');

          this.ui_controls.lastUpdatedDate = data.updateDate;
          this.cash = data.cash.cash;
          this.shares = data.shares.shares;

        } catch(error) {
          this.HANDLE_ERROR_GENERIC(error);

        } finally {
          this.REQUEST_FINALLY()

        }
      }
    },


    mounted() {
      this.FETCH_RECORDS();
    },
  }
</script>